import React from 'react';
import classes from './button.module.css';
import { Link } from 'react-router-dom';

export default function Button(props) {
  return (
    <Link className={classes.buttonShort} to={props.link}>{props.text}</Link>
  )
}
